export const validation = {
  title_es: 'required|min:3|max:100',
  text_es: 'min:3',
  group_id: 'required|min_value:1|max:11|numeric',
  type_id: 'required|min_value:1|numeric|max:11',
  shape_id: 'min_value:1|max:11|numeric',
  weight_id: 'min_value:1|max:11|numeric',
  status_id: 'required|min_value:1|numeric|max_value:9',
  suburb_id: 'min_value:1|max:11|numeric',
  gallery_id: 'min_value:1|max:11|numeric'
}

export const productFields = function () {
  return {
    title_es: null,
    text_es: null,
    group_id: null,
    type_id: null,
    shape_id: null,
    weight_id: null,
    suburb_id: null,
    gallery_id: null,
    images: null,
    plaquetas: null,
    status_id: null,
    inventory: null
  }
}

export const statusList = [
  {
    id: 1,
    name: 'Activo'
  },
  {
    id: 2,
    name: 'Inactivo'
  }
]

export const texts = {
  productEdit: {
    title: 'Editar Producto Existente',
    subtitle: 'Edita la información del producto, imágenes, existencia, etc.',
    submit: 'Actualizar Producto',
    messages: {
      success: {
        title: 'PRODUCTO ACTUALIZADO',
        text: 'Este product ha sido actualizado correctamente'
      }
    }
  },
  productNew: {
    title: 'Añadir Nuevo Producto',
    subtitle: 'Crear nuevo producto',
    submit: 'Crear Producto',
    messages: {
      success: {
        title: 'PRODUCT CREADO',
        text: 'Se ha creado correctamente el nuevo producto'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/products/moks.js